import * as http from 'axios'

export const getOrcamento = (filtro) => {
  return http.get('/orcamento', {params: filtro})
}



// WEBPACK FOOTER //
// ./src/store/orcamento/services.js